import { Component, h, Prop } from '@stencil/core';
import { SIZES } from '@local/models'

@Component({
  tag: 'cr-hstack',
  styleUrl: 'cr-hstack.css',
  shadow: true,
})
export class CrHstack {

  @Prop() size: SIZES | string = SIZES.MEDIUM;

  render() {
    return (
      <div class={`hstack ${this.size}`}>
        <slot></slot>
      </div>
    );
  }

}
